import React, { useEffect, useContext } from 'react'
import InstagramLogin from "react-instagram-login";
import { AuthContext } from '../../context/AuthContext';
import { userServices } from '../../services';
import { useHistory } from 'react-router-dom'
import { InstagramIcon, InstagramIcon2 } from '../../icons';




export default function InstagramAuthForm({ closemodel, name }) {
    const { setUser, setAccessToken, startSilentRefresh, user, setLoaded } = useContext(AuthContext)
    const history = useHistory();
    const [instaData, setInstaData] = React.useState();
    useEffect(() => {


        //axios.get(`https://graph.instagram.com/me?fields=id,username&access_token=AQCl3Hy2B4Kzds7YmdeC5WJ9zoF2-yL4emk5FTQ8ZFIy65KWVgYdDAF7wj1JsKBITnFn2Rupb3_i9muclSaPp02DoP7iHqX6W0XRIOVyvOh0RN0CQ898h4zcCStkzDszy3kgQoqj_GwH_n2gNH2wJRq2bFp_D91Sj5yhsrKVJP6aFIgfsdlyroTy1DewDuor2t28XnBPETkQCiMtIHYeSKqGVV5I8muufeLXyBNwywUi-g`).then(res=>{})
    }, [])
    const responseInstagram = (val) => {
        let payload = { code: val }
        userServices.getInsta(payload).then(res => {
            setInstaData(res)
        }
        );


    }
    useEffect(() => {
        var sendData = {
            oauth_id: instaData?.id,
            first_name: instaData?.username,
            user_type: 1,
            registered_on: new Date(),
        }

        if (instaData !== undefined) {
            setLoaded(false)
            userServices.handleOauthUser(sendData).then((result) => {
                setUser(result.data.user)
                setAccessToken(result.data.token)
                startSilentRefresh()
                history.push(`/app/dashboard`)
                closemodel()
                setLoaded(true)
            }).catch((err) => {
                setLoaded(true)
            });
        }


    }, [instaData])

    return (
        <div>


            <InstagramLogin
                clientId="375799121300157"
                cssClass='instagram_login'
                onSuccess={responseInstagram}
                onFailure={responseInstagram}
                scope='user_profile,user_media,instagram_graph_user_profile'
                redirect_uri='https://dev-client.castingbell.com/landing'
                response_type='code'>
                {/* <div className='insta_btn'><img src={require('../../assets/img/instagram.png').default} /> Signin with Instagram</div> */}
                <button className='auth_btn white-bg font-medium mt-3'>
                    <InstagramIcon2 className="w-6 h-6" aria-hidden="true" />
                    <p>{name}</p>
                </button>
            </InstagramLogin>
        </div>
    )
}
